import FlickityFade from 'flickity-fade';

function singles(frame, wrappers) {
  // sets the height of any frame passed in with the
  // tallest js-overflow-content as well as any image in that frame
  let padding = 64;
  let tallest = 0;

  wrappers.forEach((wrap) => {
    if (wrap.offsetHeight > tallest) {
      const getMarginTop = parseInt(window.getComputedStyle(wrap).marginTop);
      const getMarginBottom = parseInt(window.getComputedStyle(wrap).marginBottom);
      const getMargin = getMarginTop + getMarginBottom;
      if (getMargin > padding) {
        padding = getMargin;
      }

      tallest = wrap.offsetHeight;
    }
  });
  const images = frame.querySelectorAll('[data-overflow-background]');
  const frames = [frame, ...images];
  frames.forEach((el) => {
    el.style.setProperty('min-height', `calc(${tallest + padding}px + var(--menu-height))`);
  });
}

function doubles(section) {
  let footerLogoH = document.querySelector('[data-footer-logo]') ? document.querySelector('[data-footer-logo]').clientHeight + 20 : 0;
  const lastSection = document.querySelector('#MainContent .shopify-section:last-child [data-section-id]');
  const lastSectionAttrID = lastSection ? lastSection.getAttribute('data-section-id') : null;

  if ((lastSectionAttrID !== null && section.getAttribute('data-section-id') !== lastSectionAttrID) || !lastSection) {
    footerLogoH = 0;
  }

  if (window.innerWidth < window.theme.sizes.medium) {
    // if we are below the small breakpoint, the double section acts like two independent
    // single frames
    let singleFrames = section.querySelectorAll('[data-overflow-frame]');
    singleFrames.forEach((singleframe) => {
      const wrappers = singleframe.querySelectorAll('[data-overflow-content]');
      singles(singleframe, wrappers);
    });
    return;
  }

  // Javascript can't execute calc() (from `--outer` variable) - create a new div with width property instead `getPropertyValue('--outer')`
  const htmlObject = document.createElement('div');
  section.prepend(htmlObject);
  htmlObject.style.display = 'none';
  htmlObject.style.width = getComputedStyle(section).getPropertyValue('--outer');
  const padding = parseInt(getComputedStyle(htmlObject).getPropertyValue('width')) * 2;
  section.firstChild.remove();
  let tallest = 0;

  const frames = section.querySelectorAll('[data-overflow-frame]');
  const contentWrappers = section.querySelectorAll('[data-overflow-content]');
  contentWrappers.forEach((content) => {
    if (content.offsetHeight > tallest) {
      tallest = content.offsetHeight;
    }
  });
  const images = section.querySelectorAll('[data-overflow-background]');
  let applySizes = [...frames, ...images];
  applySizes.forEach((el) => {
    el.style.setProperty('min-height', `${tallest + padding}px`);
  });
  section.style.setProperty('min-height', `${tallest + padding + 2 + footerLogoH}px`);
}

function preventOverflow(container) {
  const singleFrames = container.querySelectorAll('.js-overflow-container');
  if (singleFrames) {
    singleFrames.forEach((frame) => {
      const wrappers = frame.querySelectorAll('.js-overflow-content');
      singles(frame, wrappers);
      document.addEventListener('theme:resize', () => {
        singles(frame, wrappers);
      });
    });

    // Reload slides if container has slideshow
    const slideshows = container.querySelectorAll('[data-slideshow-wrapper]');

    if (slideshows.length) {
      slideshows.forEach((slideshow) => {
        const slideshowInstance = FlickityFade.data(slideshow);
        if (typeof slideshowInstance !== 'undefined') {
          slideshowInstance.reloadCells();
        }
      });
    }
  }

  const doubleSections = container.querySelectorAll('[data-overflow-wrapper]');
  if (doubleSections) {
    doubleSections.forEach((section) => {
      doubles(section);
      document.addEventListener('theme:resize', () => {
        doubles(section);
      });
    });
  }
}

export default preventOverflow;
